import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { FormControl, UntypedFormBuilder } from '@angular/forms';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { OnlinetestModel } from 'projects/core/src/lib/models/onlinetest.model';

@Component({
  selector: 'app-onlinetest-basedata',
  templateUrl: './onlinetest-basedata.component.html',
  styleUrls: ['./onlinetest-basedata.component.scss']
})
export class OnlinetestBasedataComponent extends BaseForm implements OnInit {

  @Input() onlinetest: OnlinetestModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public candidateComment: string | null = null;

  public form = this.fb.group({
    for_ac: new FormControl<boolean>(false),
    for_toolbox: new FormControl<boolean>(false),
    api_active: new FormControl<boolean>(false),
    candidate_comment: new FormControl<string>(''),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    if (this.onlinetest !== null) {
      this.candidateComment = this.onlinetest.candidate_comment;
    }
    this.ui.setFocus();
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('onlinetests', this.onlinetest.id, this.form.value).subscribe({
        next: (result: any) => {
          this.onlinetest.deserialize(result.data);
          this.candidateComment = this.onlinetest.candidate_comment;
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.onlinetest.name }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  protected startEdit(): void {
    if (this.onlinetest !== null) {
      this.form.patchValue({
        for_ac: this.onlinetest.for_ac,
        for_toolbox: this.onlinetest.for_toolbox,
        api_active: this.onlinetest.api_active,
        candidate_comment: this.onlinetest.candidate_comment,
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

  public getEditorInit(): any {
    let language = 'en';
    let language_url = null;
    if (this.transloco.getActiveLang() === 'de') {
      language = 'de';
      language_url = 'assets/tiny/langs/de.js';
    }
    return {
      // height: 'calc(100% - 20px)',
      menubar: false,
      plugins: [
        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor',
        'searchreplace', 'visualblocks', 'code', 'fullscreen',
        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
      ],
      toolbar: 'undo redo | blocks | bold italic backcolor | \
        alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | link | removeformat | code',
      language,
      language_url
    };
  }

}
